import { ConsultationType, ConsultationStep } from '../consultation/consultation.model';

export class GroupWaitingModel {
  public id: string;
  public groupId: string;
  public groupREF: string;
  public groupName: string;
  public contact: string;
  public address: string;
  public email: string;
  public phone: string;
  public description: string;
  public noOfPatients: number;
  public status: ConsultationType = ConsultationType.Consultation;
  public step: ConsultationStep.InConsultation;
  public patientMembers: any[];
  public paymentTerm: string = null;
  public fileAttachments: any[];
  public countryId: string = null;
  public isActive: boolean = true;
  public departureDate: Date = null;
}





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/waiting-room/group-waiting.model.ts